import angular from "angular";
import { directiveFactory } from "../angular-core";

interface ILocalScope extends ng.IScope {
    decimalPlaces: number;
    specialEnd: string;
}

export class NumberFormatterDirective implements ng.IDirective<ILocalScope> {
    static componentName: string = "numberFormatter";
    static $inject = ["$filter"];
    restrict = "A";
    require = "?ngModel";
    scope = {
        decimalPlaces: "@",
        specialEnd: "@"
    };

    constructor(protected $filter: ng.IFilterService) {}

    formatter = (value: string, decimalPlaces: number, specialEnd: string) => {
        value = value || " ";
        var numb = value.toString().replace(/,/g, ".").replace(/\s/g, "");
        if (specialEnd) return this.$filter("number")(numb.replace(specialEnd, ""), decimalPlaces) + specialEnd;

        return this.$filter("number")(numb, decimalPlaces);
    };

    unformatter = (str: string) => {
        if (str) {
            var toNumber = str.toString().replace(/,/g, ".").replace(/\s/g, "");
            return parseFloat(toNumber);
        }
        return "";
    };

    link = (scope: ILocalScope, element: JQLite, attrs: ng.IAttributes, ngModel: $TSFixMe) => {
        ngModel.$formatters.unshift(() => {
            if (scope.specialEnd)
                return this.$filter("number")(ngModel.$modelValue, scope.decimalPlaces) + scope.specialEnd;

            return this.$filter("number")(ngModel.$modelValue, scope.decimalPlaces);
        });
        ngModel.$parsers.unshift(this.unformatter);

        element.bind("blur", () => {
            element.val(this.formatter(ngModel.$viewValue, scope.decimalPlaces, scope.specialEnd));
        });

        element.bind("focus", () => {
            element.val(this.unformatter(ngModel.$modelValue));
        });
    };
}

angular
    .module("topline.directives")
    .directive(NumberFormatterDirective.componentName, directiveFactory(NumberFormatterDirective));
